export const ApiUrls = {
    getAllFunctionalityforRole:'/api/digital/core/Organization/GetAllFunctionalityforRole',
    getMeeting:'/api/digital/core/Meeting/GetMeeting',
    createUser:'/api/digital/core/Meeting/CreateUser',
    addUsersToChatThread:'/api/digital/core/Meeting/AddUsersToChatThread',
    UploadAttachmentinChat:'/api/digital/core/Meeting/UploadAttachmentinChat',
    InsertMeetingHistory:'/api/digital/core/Meeting/InsertMeetingHistory',
    getDomainDetails : '/api/UAD/GetDomainDetails',
    GetTokenByAccessCode : '/api/UAD/GetTokenByAccessCode'
  };